function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 13.2497C10.3137 13.2497 13 10.5634 13 7.24969C13 3.93599 10.3137 1.24969 7 1.24969C3.68629 1.24969 1 3.93599 1 7.24969C1 10.5634 3.68629 13.2497 7 13.2497ZM7 14.2497C10.866 14.2497 14 11.1157 14 7.24969C14 3.3837 10.866 0.249695 7 0.249695C3.13401 0.249695 0 3.3837 0 7.24969C0 11.1157 3.13401 14.2497 7 14.2497Z",
  fill: "#E61A6B"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.81671 4.4838C4.90721 4.3933 4.95246 4.34805 5.00364 4.32871C5.06154 4.30683 5.12543 4.30683 5.18333 4.3287C5.23452 4.34805 5.27977 4.39329 5.37026 4.48379L7.00061 6.11411L8.63091 4.48386C8.72141 4.39337 8.76665 4.34812 8.81784 4.32877C8.87574 4.3069 8.93963 4.3069 8.99753 4.32877C9.04872 4.34812 9.09396 4.39336 9.18446 4.48386L9.76645 5.06583C9.85694 5.15633 9.90219 5.20158 9.92153 5.25277C9.94341 5.31066 9.94341 5.37455 9.92154 5.43245C9.90219 5.48364 9.85695 5.52889 9.76646 5.61938L8.13619 7.24967L9.76645 8.87999C9.85694 8.97049 9.90219 9.01573 9.92154 9.06692C9.94341 9.12482 9.94341 9.18871 9.92154 9.24661C9.90219 9.2978 9.85695 9.34305 9.76645 9.43354L9.18448 10.0155C9.09398 10.106 9.04873 10.1513 8.99754 10.1706C8.93965 10.1925 8.87576 10.1925 8.81786 10.1706C8.76667 10.1513 8.72142 10.106 8.63093 10.0155L7.00062 8.38526L5.37025 10.0156C5.27976 10.1061 5.23451 10.1513 5.18332 10.1707C5.12542 10.1925 5.06153 10.1925 5.00363 10.1707C4.95244 10.1513 4.9072 10.1061 4.8167 10.0156L4.23471 9.4336C4.14422 9.3431 4.09897 9.29785 4.07963 9.24667C4.05775 9.18877 4.05775 9.12488 4.07962 9.06698C4.09897 9.01579 4.14421 8.97054 4.23471 8.88005L5.86504 7.24969L4.23474 5.61933C4.14425 5.52884 4.099 5.48359 4.07965 5.4324C4.05777 5.3745 4.05777 5.31061 4.07965 5.25271C4.09899 5.20152 4.14424 5.15627 4.23474 5.06578L4.81671 4.4838Z",
  fill: "#E61A6B"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/DeleteIcon.57b18a95.svg";
export { SvgComponent as ReactComponent };